const allowed = [
  {
    name: "being-remembered.exe",
    note: "I'd rather be the weird Windows 98 portfolio than the one you forgot by Tuesday."
  },
  {
    name: "read-before-write.dll",
    note: "Code is read more than it's written. Clear names, small functions, comments only when WHY isn't obvious."
  },
  {
    name: "tiny-ugly-things.bat",
    note: "Half the projects I'm proud of started as a stupid weekend hack. Side projects are how I actually learn."
  },
  {
    name: "teaching.exe",
    note: "Three years teaching computer basics to elders. If you can't explain it, you don't really get it yet."
  },
  {
    name: "useful-AI.dll",
    note: "Recommendation systems that make someone's evening better. Pipelines that save a team an hour. Glamour-free, useful work."
  },
  {
    name: "honest-bug-report.log",
    note: "I'd rather flag a bug early and look dumb for ten minutes than ship it."
  },
  {
    name: "diverse-teams.cfg",
    note: "Three Erasmus exchanges taught me more than any single classroom could. Teams that look alike build products that look alike."
  }
];

const blocked = [
  {
    name: "vibe-coding.exe",
    note: "Pasting a model's output into prod without reading it. I use AI tools every day - as a collaborator, not a replacement for thinking."
  },
  {
    name: "complexity-flex.dll",
    note: "Three lines and a clear name will do. Abstractions are taxes - only pay them when you have to."
  },
  {
    name: "AI-hype-no-ethics.msi",
    note: "Energy and ethics belong in every team's vocabulary, not in a once-a-year CSR slide."
  },
  {
    name: "performative-process.bat",
    note: "Meetings that should've been an email, dashboards no one reads, rituals that survive their reason."
  },
  {
    name: "gatekeeping.dll",
    note: "Nobody is born knowing what a pointer is. 'You should already know this' is how we lose good people early."
  },
  {
    name: "soulless-employer.exe",
    note: "Done that. Won't do it again unless I genuinely have to."
  }
];

const quarantine = [
  {
    name: "ship-it-vs-not-ready.tmp",
    note: "Where exactly the line is. I lean ship-it. Sometimes too much."
  },
  {
    name: "saying-no.tmp",
    note: "How to do it without feeling guilty about it."
  },
  {
    name: "dutch-articles.dat",
    note: "Whether 'het' or 'de' goes in front of any given Dutch noun. Heuristic still uncalibrated."
  }
];

const ruleRow = (icon, color, r) => `
  <li class="fw-row">
    <span class="fw-ico" style="color:${color}">${icon}</span>
    <span class="fw-name">${r.name}</span>
    <span class="fw-note">${r.note}</span>
  </li>
`;

const allowedRows = allowed.map(r => ruleRow("&#10003;", "#0a7d28", r)).join("");
const blockedRows = blocked.map(r => ruleRow("&#10007;", "#a40000", r)).join("");
const quarantineRows = quarantine.map(r => ruleRow("&#9888;", "#a06000", r)).join("");

const logLines = [
  `[09:14:22] <span class="lg-block">BLOCKED</span>     outbound  vibe-coding.exe  &rarr;  prod.py`,
  `[09:13:51] <span class="lg-allow">ALLOWED</span>     inbound   curiosity.dll`,
  `[09:13:09] <span class="lg-allow">ALLOWED</span>     outbound  teaching.exe     &rarr;  community.org`,
  `[09:12:44] <span class="lg-block">BLOCKED</span>     inbound   meeting-that-shouldve-been-email.msg`,
  `[09:12:08] <span class="lg-quar">QUARANTINE</span>  dutch-articles.dat (de? het?)`,
  `[09:11:30] <span class="lg-allow">ALLOWED</span>     outbound  honest-bug-report.log`
].join("<br/>");

const manifestoHTML = `
<style>
*:has(> .fw-wrap) {
  background: #c0c0c0 !important;
  margin: 0 !important;
  display: flex !important;
  flex-direction: column !important;
}
.fw-wrap {
  font-family: "MS Sans Serif", Tahoma, sans-serif;
  background: #c0c0c0;
  color: #000;
  font-size: 12px;
  padding: 8px 10px 10px;
  min-height: 100%;
  flex: 1 1 auto;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.fw-header {
  background: linear-gradient(90deg, #000080 0%, #1084d0 100%);
  color: #fff;
  padding: 6px 10px;
  display: flex;
  align-items: center;
  gap: 10px;
  border: 2px solid #000;
  border-style: solid;
}
.fw-shield {
  font-size: 22px;
  line-height: 1;
}
.fw-title {
  flex: 1;
  font-weight: bold;
  font-size: 13px;
  letter-spacing: 0.5px;
}
.fw-status {
  background: #00a000;
  color: #fff;
  font-weight: bold;
  font-size: 11px;
  padding: 2px 8px;
  border: 1px solid #004000;
  letter-spacing: 1px;
}
.fw-scan {
  font-size: 11px;
  opacity: 0.9;
  font-style: italic;
}
.fw-intro {
  background: #ffffe1;
  border: 1px solid #000;
  padding: 6px 8px;
  font-size: 11.5px;
}
.fw-fieldset {
  border: 2px groove #c0c0c0;
  padding: 6px 8px 8px;
  background: #c0c0c0;
}
.fw-fieldset legend {
  font-weight: bold;
  font-size: 11px;
  letter-spacing: 1px;
  padding: 0 6px;
  background: #c0c0c0;
}
.fw-fieldset.allow legend { color: #0a7d28; }
.fw-fieldset.block legend { color: #a40000; }
.fw-fieldset.quar  legend { color: #a06000; }
.fw-list {
  list-style: none;
  margin: 0;
  padding: 0;
}
.fw-row {
  display: grid;
  grid-template-columns: 22px minmax(180px, 240px) 1fr;
  gap: 8px;
  align-items: baseline;
  padding: 3px 4px;
  border-bottom: 1px dotted #888;
  font-size: 12px;
}
.fw-row:last-child { border-bottom: none; }
.fw-row:hover {
  background: #0a246a;
  color: #fff;
}
.fw-row:hover .fw-name,
.fw-row:hover .fw-note,
.fw-row:hover .fw-ico { color: #fff !important; }
.fw-ico {
  font-size: 14px;
  font-weight: bold;
  text-align: center;
}
.fw-name {
  font-family: "Courier New", monospace;
  font-weight: bold;
  font-size: 12px;
}
.fw-note {
  font-size: 11.5px;
  line-height: 1.35;
}
.fw-log-wrap {
  border: 2px inset #c0c0c0;
  background: #000;
  color: #00ff66;
  font-family: "Courier New", monospace;
  font-size: 11px;
  padding: 6px 8px;
  line-height: 1.55;
  max-height: 110px;
  overflow: hidden;
}
.fw-log-title {
  color: #aaa;
  font-size: 10px;
  margin-bottom: 4px;
  letter-spacing: 1px;
}
.lg-allow { color: #00ff66; font-weight: bold; }
.lg-block { color: #ff5555; font-weight: bold; }
.lg-quar  { color: #ffcc00; font-weight: bold; }
.fw-foot {
  font-size: 11px;
  font-style: italic;
  text-align: center;
  opacity: 0.75;
}
@media (max-width: 560px) {
  .fw-row { grid-template-columns: 22px 1fr; }
  .fw-row .fw-note { grid-column: 2 / 3; }
}
</style>

<div class="fw-wrap">
  <div class="fw-header">
    <span class="fw-shield">&#128737;</span>
    <span class="fw-title">Personal Firewall &mdash; Real-time Protection</span>
    <span class="fw-scan">Last scan: today, 09:14</span>
    <span class="fw-status">PROTECTED</span>
  </div>

  <div class="fw-intro">
    This is a personal rules file. It's opinionated on purpose. If you disagree with half of it,
    that's fine &mdash; we'll have something to talk about over coffee.
  </div>

  <fieldset class="fw-fieldset allow">
    <legend>&#10003; ALLOWED TRAFFIC &mdash; what I stand for</legend>
    <ul class="fw-list">${allowedRows}</ul>
  </fieldset>

  <fieldset class="fw-fieldset block">
    <legend>&#10007; BLOCKED TRAFFIC &mdash; what I stand against</legend>
    <ul class="fw-list">${blockedRows}</ul>
  </fieldset>

  <fieldset class="fw-fieldset quar">
    <legend>&#9888; QUARANTINE &mdash; under review</legend>
    <ul class="fw-list">${quarantineRows}</ul>
  </fieldset>

  <div class="fw-log-wrap">
    <div class="fw-log-title">&gt;&gt; LIVE EVENT LOG</div>
    ${logLines}
  </div>

  <div class="fw-foot">--EOF-- &middot; rules reviewed continuously &middot; user signature: noé.guengant</div>
</div>
`;

export default manifestoHTML;
